import { render, staticRenderFns } from "./HistoryComment.vue?vue&type=template&id=5f7c051d&scoped=true&"
import script from "./HistoryComment.vue?vue&type=script&lang=js&"
export * from "./HistoryComment.vue?vue&type=script&lang=js&"
import style0 from "./HistoryComment.vue?vue&type=style&index=0&id=5f7c051d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7c051d",
  null
  
)

export default component.exports